import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { API_URL_V4 } from 'src/environments/environment.local';
import { Vehicle } from '../models/vehicle.interface';

@Injectable({ providedIn: 'root' })
export class VehicleApi {
  private readonly vehiclesUrl: string = `${API_URL_V4}/vehicles`;

  private http: HttpClient = inject(HttpClient);

  getVehicles$(): Observable<Vehicle[]> {
    return this.http.get(this.vehiclesUrl).pipe(
      map((res: { data: Vehicle[] }) => {
        return res.data;
      })
    );
  }
}
